<!-- Base.Dialog.vue (client-lms) -->
<template>
  <Teleport to="body">
    <Transition name="dialog">
      <div v-if="modelValue" class="lms_dialog_overlay" @click.self="onCancel">
        <div class="lms_dialog">
          <div class="lms_dialog_body">
            <p class="lms_dialog_message">
              <slot>{{ message }}</slot>
            </p>
          </div>
          <div class="lms_dialog_actions">
            <button
              v-if="showCancel"
              type="button"
              class="lms_dialog_btn lms_dialog_btn_cancel"
              @click="onCancel"
            >
              {{ cancelText }}
            </button>
            <button
              type="button"
              class="lms_dialog_btn lms_dialog_btn_confirm"
              @click="onConfirm"
            >
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
const modelValue = defineModel<boolean>({ required: true });

const props = defineProps({
  message: { type: String, default: "" },
  confirmText: { type: String, default: "확인하기" },
  cancelText: { type: String, default: "취소" },
  showCancel: { type: Boolean, default: true },
});

const emit = defineEmits<{
  (e: "confirm"): void;
  (e: "cancel"): void;
}>();

const onConfirm = () => {
  emit("confirm");
  modelValue.value = false;
};

const onCancel = () => {
  emit("cancel");
  modelValue.value = false;
};
</script>

<style scoped>
.lms_dialog_overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10000;
}

.lms_dialog {
  display: inline-block;
  width: auto;
  max-width: calc(100vw - 48px);
  padding: 24px;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.lms_dialog_body {
  padding: 0;
}

.lms_dialog_message {
  margin: 0;
  font-family: "Pretendard", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: rgba(0, 0, 0, 0.7);
  white-space: pre;
}

.lms_dialog_actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 396px;
  padding: 24px 0 0;
}

.lms_dialog_btn {
  height: 48px;
  padding: 0 24px;
  border-radius: 4px;
  font-family: "Pretendard", sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

.lms_dialog_btn_cancel {
  background-color: var(--lms-grey-300);
  color: rgba(0, 0, 0, 0.4);
  /* border: 1px solid #E0E0E0; */
}

.lms_dialog_btn_cancel:hover {
  background-color: #F6F7F7;
}

.lms_dialog_btn_confirm {
  background-color: #2A2B2B;
  color: #FFFFFF;
}

.lms_dialog_btn_confirm:hover {
  background-color: #3A3B3B;
}

/* Transition */
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.2s;
}
.dialog-enter-active .lms_dialog,
.dialog-leave-active .lms_dialog {
  transition: transform 0.2s;
}
.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
}
.dialog-enter-from .lms_dialog {
  transform: scale(0.95);
}

@media (max-width: 768px) {
  .lms_dialog_overlay {
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .lms_dialog {
    width: calc(100vw - 40px) !important;
    max-width: 360px;
    border-radius: 4px;
  }

  .lms_dialog_body {
    padding: 28px 20px 20px;
  }

  .lms_dialog_message {
    font-size: 14px;
    line-height: 1.5;
    word-break: keep-all;
  }

  /* PC 고정폭(396px)은 모바일 다이얼로그(max-width 360px)보다 넓어 버튼이 잘림 → 모바일만 컨테이너 폭에 맞춤 */
  .lms_dialog_actions {
    gap: 8px;
    width: 100%;
    padding: 0 20px 20px;
  }

  .lms_dialog_btn {
    height: 36px;
    min-width: 64px;
    padding: 0 16px;
    font-size: 13px;
  }
}
</style>
